module.exports = __webpack_public_path__ + "img/Oracle.a270a95.svg";